/* eslint-disable prettier/prettier */
/* eslint-disable no-useless-escape */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { Select, Spin, message } from "antd";
import { Auth } from "aws-amplify";
import dayjs from "dayjs";
import { getMessaging, getToken } from "firebase/messaging";
import { navigate, Link } from "gatsby";
import isEmpty from "lodash/isEmpty";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { isPossiblePhoneNumber } from "react-phone-number-input";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import io from "socket.io-client";
import { signalLogoutStarted } from "../library/logoutOverlay";
import { runPreLogout } from "../library/preLogout";
// eslint-disable-next-line no-unused-vars
import firebase from "./firebaseInit/firebase";
import { UserContext } from "../amplify/authenticator-provider";
import { GRAPHQL_URL, V1_SOCKET_URL } from "../config";
import {
  CREATE_FCM_DEVICE,
  CREATE_USAGE_EVENT,
  DELETE_FCM_DEVICE,
  UPDATE_USER,
  UPDATE_USER_DEFAULT_COMPANY_ID,
  UPDATE_USER_PHONE,
} from "../graphql/mutation";
import {
  GET_APPLICATION_LEVELS,
  GET_APPLICATION_USE_CASES,
  GET_CRM_INTEGRATION_TYPE,
  GET_LEAD_PHONE_LOCATION,
  GET_LOCATIONS,
  GET_UNREAD_NOTIFICATIONS_COUNT,
  GET_USER_ACCESS_PERMISSIONS,
  ME,
} from "../graphql/query";
import { purgePersistedState } from "../redux/store";
import { usePageVisibilityWithBeatTracker } from "../hooks";
import useLang from "../hooks/useLang";
import { getCognitoRoles, getEffectiveCognitoRoles } from "../hooks/utils";
import { isImpersonating } from "../helpers/impersonation";
import checkIcon from "../icons/svg/Toast/check.svg";
import errorIcon from "../icons/svg/Toast/error.svg";
import infoIcon from "../icons/svg/Toast/info.svg";
import warningIcon from "../icons/svg/Toast/warning.svg";
import { colorConfig } from "../library/colorConfig";
import { AccessPermissionAction } from "../library/constants";
import { SOCKET_EVENTS } from "../library/socketHelper";
import { checkAccessPermission, checkLocation } from "../library/helpers";
import BrowserExtensionPopupV2 from "../pages/browser-extension-v2";
import BrowserExtensionPopupV3 from "../pages/browser-extension-v3";
import BrowserExtensionPopupV4 from "../pages/browser-extension-v4";
import { setAiApplicationUseCases, setApplicationLevels } from "../redux/slices/aiSlice";
import { resetApiCacheStore, setCrmType } from "../redux/slices/apiCacheSlice";
import { resetFilters } from "../redux/slices/callReportSlice";
import { reducerSetAppointmentUserIds } from "../redux/slices/appointmentSlice";
import { setCompanyDetails } from "../redux/slices/companySlice";
import { setMobileView } from "../redux/slices/isMobile";
import { getLocationId, setLocationIdSlice } from "../redux/slices/locationSlice";
import { fsIdentify, posthogIdentify } from "./layoutComponent/layoutHelpers";
import MainLayout from "./layoutComponent/mainLayout";
import UpdatePhone from "./layoutComponent/updatePhone";
import Toast from "./toast/Toast";
import { setLeadCountChange } from "../redux/slices/leadSlice";
import { isReportRouteMatch } from "../utils/ReportUtils";
import "../i18n";

const endPoint = GRAPHQL_URL.replace("/graphql", "");
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone"); // dependent on utc plugin

dayjs.extend(timezone);
dayjs.extend(utc);

const PINE_BELT_CHEVEROLATE_LAKEWOOD = "Pine Belt Chevrolet Lakewood";
const PINE_BELT_CHRYSLER_JDM = "Pine Belt Chrysler Jeep";

let queryStringLocation = "";

export const ErrorContainter = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  background-size: cover;
  padding: 5em;
  font-family: Helvetica;
  text-align: center;
`;

const Layout = props => {
  const { children, authData, updateUser, updateUserWithPermissions } = props;
  const locationIdslice = useSelector(state => getLocationId(state));

  const dispatch = useDispatch();
  const isSigningOut = React.useRef(false);

  const [lang] = useLang();
  /**
   * @type {import('socket.io-client').Socket<DefaultEventsMap, DefaultEventsMap>} socket
   */
  const {
    user,
    setNotificationData,
    setUser,
    setSocketMsgSelectedLead,
    setmodal,
    persistor,
    socket,
    setSocket,
    setNewLead,
    setAddNewLead,
    notificationData,
  } = useContext(UserContext);

  let toastProperties = null;
  const location = window.location.pathname;
  const locationChatBot = window.location.search;
  const locationParamas = new URLSearchParams(locationChatBot);
  const locationName = locationParamas.get("locationName");
  // Unified CRM contract: extension iframe URLs now emit `crmIntegrationType`
  // instead of the legacy `crmName`. Default to "DS" to preserve the prior
  // behavior of treating an unknown-CRM context as DealerSocket for the
  // location-load gate.
  const getCRM = locationParamas.get("crmIntegrationType") || "DS";
  const accessPayload = authData.signInUserSession.accessToken.payload;
  const checkValue = true;
  const autoDeleteTime = 10;
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const loc = urlParams.get("loc");
  const internalMessageId = urlParams.get("message_id");
  const currentPath = `/${children.props.location.pathname.split("/")[1]}`;
  const { filters } = useSelector(state => state.appointments);
  const { userIds } = filters;
  const [userFullName, setUserFullName] = useState(user ? user.fullName : "");
  const [userAccounts, setUserAccounts] = useState(user ? user.userAccounts : "");
  const [userAccountOptions, setUserAccountOptions] = useState(null);
  const [showUserAccountOptions, setShowUserAccountOptions] = useState(false);
  const [showSupportModal, setShowSupportModal] = useState(false);

  const [currentUserCompany, setcurrentUserCompany] = useState(user.company.id);
  // const [locationList, setLocationList] = useState([]);
  const [phone, setPhone] = useState("");
  const [locationId, setLocation] = useState();
  const [mobileaddModal, setmobileaddModal] = useState({
    modalState: false,
    data: {},
  });
  const [contentStyle, setContentStyle] = useState(false);
  const [canRedirect, setCanRedirect] = useState(true);
  const [location2, setlocation2] = useState([]);
  const [gotLocationId, setGotLocationId] = useState(getCRM !== "DS");
  const [list, setList] = useState([]);
  const [skipper, setSkipper] = useState({
    permissions: false,
  });

  const [changed, setchanged] = useState(false);

  // Check if both loc and internalMessageId are available from URL
  const isMessageIdAndLocAvailable = loc && internalMessageId;

  const { loading: permissionLeader, refetch: refetchPermissions } = useQuery(
    GET_USER_ACCESS_PERMISSIONS,
    {
      fetchPolicy: "cache-and-network",
      skip: skipper.permissions,
      onCompleted: resp => {
        if ((resp?.getUserPermissionActions || []).length > 0) {
          const userDetail = {
            ...user,
            accessControlPermissions: resp?.getUserPermissionActions,
          };
          setUser({ ...userDetail });
          setSkipper({ ...skipper, permissions: true });
        }
      },
    }
  );

  const showToast = (type, title, message, leadId = "") => {
    const id = Math.floor(Math.random() * 101 + 1);

    switch (type) {
      case "success":
        toastProperties = {
          id,
          title: title,
          description: message,
          backgroundColor: colorConfig.primaryDark,
          icon: checkIcon,
          lead_id: leadId,
        };
        break;
      case "danger":
        toastProperties = {
          id,
          title: title,
          description: message,
          backgroundColor: "#d9534f",
          icon: errorIcon,
        };
        break;
      case "info":
        toastProperties = {
          id,
          title: title,
          description: message,
          backgroundColor: "#5bc0de",
          icon: infoIcon,
        };
        break;
      case "warning":
        toastProperties = {
          id,
          title: title,
          description: message,
          backgroundColor: "#f0ad4e",
          icon: warningIcon,
        };
        break;
      default:
        setList([...list]);
        break;
    }
    setList(prev => [...prev, toastProperties]);
  };

  const [createFcmDevice] = useMutation(CREATE_FCM_DEVICE);
  const [deleteFcmDevice] = useMutation(DELETE_FCM_DEVICE);

  // Switching company reloads to "/" so every layer re-hydrates under the new
  // identity — but redux-persist re-hydrates the OLD company's filters straight
  // back out of localStorage. Those filters hold company-scoped ids
  // (opportunity type/status/source, users, teams) plus their chip counts, so
  // the new company opened with counts for selections that don't exist there
  // and a lead list filtered down to nothing. Purge the persisted state BEFORE
  // navigating; the reload then starts from slice defaults, and the
  // MY_CONVERSATIONS restriction is re-applied from the new company's
  // permissions on mount rather than inherited from the old one.
  const [updateUserDefaultCompanyId] = useMutation(UPDATE_USER_DEFAULT_COMPANY_ID, {
    onCompleted: () => {
      purgePersistedState();
      window.location.href = "/";
    },
  });

  const [getMe, { data: meData, error: meError }] = useLazyQuery(ME, {
    // fetchPolicy: "network-only",
    onCompleted: async result => {
      // Store company data in Redux
      if (result?.me?.company) {
        dispatch(setCompanyDetails(result?.me?.company));
      }
      // console.log("layout.js:getMe completed");
      await updateUser(result?.me);

      const showPhoneAdder = localStorage.getItem("showPhone");
      if (
        showPhoneAdder === "true" &&
        getCognitoRoles(accessPayload)[0] !== "ADMIN" &&
        (result?.me?.phone === null ||
          result?.me?.phone === undefined ||
          result?.me?.phone?.length === 0)
      ) {
        const obj = {
          userId: result.me.id,
          firstName: result.me.firstName,
          lastName: result.me.lastName,
          email: result.me.email,
        };
        setmobileaddModal({
          modalState: true,
          data: {
            ...obj,
          },
        });
      }
      const allActiveUserAccounts = result.me.userAccounts.filter(res => {
        if (!res.company.isDisabled && !res.isDisabled) {
          return true;
        }
      });
      const allUserAccounts = allActiveUserAccounts.map(res => {
        return res.company;
      });
      const isUserActiveInCompany = allActiveUserAccounts.filter(res => {
        if (+result.me.company.id === +res.company.id) {
          return res.company;
        }
      });
      if (
        (result.me.company.isDisabled || isUserActiveInCompany.length === 0) &&
        allUserAccounts.length > 0
      ) {
        updateUserDefaultCompanyId({
          variables: { companyId: allUserAccounts[0].id, userId: result.me.id },
        });
        setCanRedirect(false);
        user.company.isDisabled = false;
      }
    },
  });

  const [{ loading }] = useMutation(UPDATE_USER, {
    onCompleted: data => {
      if (data.updateUser.ok) {
        message.success(lang.phoneAdded);
        setmobileaddModal({ modalState: false, data: {} });
        localStorage.setItem("showPhone", "false");
      }
    },
  });

  const [updateUserPhone, { loading: phoneSpinner }] = useMutation(UPDATE_USER_PHONE, {
    onCompleted: data => {
      if (data.updateUserPhone.statusCode === 200) {
        message.success(data.updateUserPhone.message || lang.phoneAdded);
        setmobileaddModal({ modalState: false, data: {} });
        localStorage.setItem("showPhone", "false");
      } else {
        message.error(data.updateUserPhone.message || lang.invalidPhoneLookup);
      }
    },
  });

  const getActiveCrmIntegration = currentLocationId => {
    let type = "";
    if ((meData?.me?.company?.crmIntegration || []).length > 0) {
      const findIndex = (meData?.me?.company?.crmIntegration).findIndex(
        el => el.active && String(el.locationId) === String(currentLocationId)
      );

      if (findIndex > -1) {
        type = meData?.me?.company?.crmIntegration[findIndex].integrationType;
      }
    }
    return type;
  };

  const setQueryStringLocation = locations => {
    try {
      if (queryStringLocation !== "") {
        const findIndex = (locations || []).findIndex(el => +el.id === +queryStringLocation);
        if (findIndex > -1) {
          setLocation(queryStringLocation);
          sessionStorage.setItem("currentLocationId", queryStringLocation);
          const crmIntegrationType = getActiveCrmIntegration(location?.id);
          setUser({
            ...user,
            locationId: queryStringLocation,
            company: { ...user.company, crmIntegrationType },
          });
        }
      }
    } catch (error) {
      console.log("Error in setQueryStringLocation", error);
    }
  };

  const [getLeadLocationByPhone] = useLazyQuery(GET_LEAD_PHONE_LOCATION, {
    fetchPolicy: "network-only",
    variables: { phone },
    skip:
      phone === "" ||
      phone === "undefined" ||
      !phone ||
      isReportRouteMatch(window.location.pathname) ||
      isMessageIdAndLocAvailable, // skip if loc and internalMessageId are present
    onCompleted: result => {
      if (phone && phone !== "undefined") {
        const locId = result?.getLeadPhoneLocation?.id || "";
        const locationIndex = location2.findIndex(el => +el.id === +locId);
        if (locId !== "") {
          if (locationIndex !== -1 && !sessionStorage.getItem("currentLocationId")?.includes(",")) {
            if (locId !== "") {
              const id = sessionStorage.getItem("currentLocationId");
              if (id !== locId) {
                sessionStorage.setItem("currentLocationId", locId);
                +locationIdslice !== +id && dispatch(setLocationIdSlice({ locationId: locId }));
              }
            }
          } else {
            const id = sessionStorage.getItem("currentLocationId");
            if (id !== location2[0]?.id && !id?.includes(",")) {
              sessionStorage.setItem("currentLocationId", location2[0]?.id);
              +locationIdslice !== +id &&
                dispatch(setLocationIdSlice({ locationId: location2[0]?.id }));
            }
          }
        }
        setmodal(true);
      }
    },
  });

  const parseLocations = (defaultLocation, locations) => {
    if (
      queryStringLocation !== "" &&
      queryStringLocation !== undefined &&
      window.location.search.match(/^loc$/)
    ) {
      setQueryStringLocation(locations);
    } else if (locations.length > 0) {
      // const location = locations.find(el => el.isDefault);
      // `defaultLocation` arrives from the caller as a one-element array
      // (`[{ ...meData.me.location }]`), so reading `.id` straight off it was
      // always undefined — which `setItem` then stored as the STRING
      // "undefined". That only surfaced when no location was set yet (a
      // freshly-opened tab, e.g. an impersonation session), and it stuck,
      // because "undefined" is a non-empty string: the location picker then
      // rendered "undefined". Normalize to the object, and only commit a real id.
      const defaultLoc = Array.isArray(defaultLocation) ? defaultLocation[0] : defaultLocation;
      const storedLocationId = sessionStorage.getItem("currentLocationId");
      // Treat a previously-stored "undefined" as unset so an affected tab heals.
      const hasStoredLocation = !isEmpty(storedLocationId) && storedLocationId !== "undefined";
      // Don't override location if 'loc' parameter is present in URL
      if (defaultLoc?.id && !hasStoredLocation && !loc) {
        setLocation(String(defaultLoc.id));
        const crmIntegrationType = getActiveCrmIntegration(defaultLoc.id);
        sessionStorage.setItem("currentLocationId", defaultLoc.id);
        setUser({
          ...user,
          company: { ...user.company, crmIntegrationType },
        });
      }
    }
  };

  useEffect(() => {
    if (meData) {
      const defaultId = [{ ...meData?.me?.location }];

      const duplicates = (meData?.me?.locations || []).map(item => item?.location);
      // ! if will only run if get locationName param from url (which basically will get from DS)
      if (locationName) {
        setGotLocationId(false);

        // * finding the locationId from the locaiton name for DS
        const locationData = duplicates?.filter(
          loctionEl =>
            loctionEl?.title?.toLowerCase() ===
            (PINE_BELT_CHEVEROLATE_LAKEWOOD?.toLowerCase() === locationName?.toLowerCase()
              ? "pine belt chevrolet"
              : PINE_BELT_CHRYSLER_JDM?.toLowerCase() === locationName?.toLowerCase()
              ? "pine belt chrysler jeep dodge ram"
              : locationName?.toLowerCase())
        );

        const route = `${location.split("/")[1]}`.replace("/", "");
        const phone = `${location.split("/")[2]}`.replace("/", "");
        if (
          !window.location.search.match(/^loc$/) &&
          locationData?.length > 0 &&
          locationData[0]?.id !== sessionStorage.getItem("currentLocationId")
        ) {
          sessionStorage.getItem("currentLocationId") !== locationData[0]?.id &&
            dispatch(setLocationIdSlice({ locationId: locationData[0]?.id }));
          sessionStorage.setItem("currentLocationId", locationData[0]?.id);
          setGotLocationId(true);
          if (!window.location.pathname.includes("review")) {
            window.history.pushState(
              "",
              "",
              `/${route}/${phone}${window.location.search}&loc=${locationData[0]?.id}`
            );
          }
        } else {
          setGotLocationId(true);
          setmodal(true);
        }
      }

      if (duplicates.length > 0) {
        parseLocations(defaultId, duplicates);
        setlocation2([...duplicates]);
      } else {
        parseLocations(defaultId, [...defaultId]);
        setlocation2([...defaultId]);
      }

      // skip fetching lead location if phone is not present or is invalid and internalMessageId and loc are present
      if (phone !== "" && phone !== "undefined" && phone && !isMessageIdAndLocAvailable) {
        getLeadLocationByPhone();
      } else {
        if (locationName) return;
        setmodal(true);
      }
    }
  }, [meData]);

  const { data: notificationsCount, refetch: refetchNotificationsCount } = useQuery(
    GET_UNREAD_NOTIFICATIONS_COUNT
  );

  useEffect(() => {
    if (notificationData && notificationData.refresh) {
      refetchNotificationsCount();
    }
  }, [notificationData]);

  const [createUsageEvent] = useMutation(CREATE_USAGE_EVENT, {
    onCompleted: res => {
      const now = dayjs();
      const eventId = sessionStorage.getItem("eventId");
      const controlTime = sessionStorage.getItem("controlTime");
      const diff = now.diff(controlTime, "days");
      if (!eventId) {
        sessionStorage.setItem("eventId", res.createUsageEvent.event.id);
        sessionStorage.setItem("controlTime", now);
      } else if (eventId && diff >= 1) {
        sessionStorage.removeItem("eventId");
        sessionStorage.removeItem("controlTime");
      }
    },
  });
  useQuery(GET_APPLICATION_USE_CASES, {
    fetchPolicy: "cache-and-network",
    onCompleted: res => {
      if ((res?.getApplicationUseCases || []).length > 0) {
        dispatch(setAiApplicationUseCases(res?.getApplicationUseCases || []));
      }
    },
  });
  useQuery(GET_APPLICATION_LEVELS, {
    fetchPolicy: "cache-and-network",
    onCompleted: res => {
      if ((res?.getApplicationLevels || []).length > 0) {
        dispatch(setApplicationLevels(res?.getApplicationLevels || []));
      }
    },
  });
  usePageVisibilityWithBeatTracker(({ verb, duration }) => {
    if (Auth.user) {
      const storedEventId = sessionStorage.getItem("eventId");
      createUsageEvent({
        variables: {
          verb,
          context: location,
          duration,
          eventId: storedEventId !== undefined ? storedEventId : null,
        },
      });
    }
  });

  const handleisAll = () => {
    if (sessionStorage.getItem("currentLocationId")?.includes(",")) {
      return true;
    }
    return false;
  };

  const setUserAccessLocations = user => {
    if (user) {
      const locations = (user?.locations || []).map(el => el.location);
      if (locations.length > 0) {
        const location = locations.find(el => +el?.id === +user?.locationId);
        if (location && isEmpty(sessionStorage.getItem("currentLocationId"))) {
          setLocation(String(location?.id || ""));
          const crmIntegrationType = getActiveCrmIntegration(location?.id);
          setUser({
            ...user,
            company: { ...user.company, crmIntegrationType },
          });
        }
      }

      if (loc) {
        const locationIndex = locations.findIndex(el => +el.id === +loc);
        +locationIdslice !== +sessionStorage.getItem("currentLocationId") &&
          dispatch(setLocationIdSlice({ locationId: loc }));
        sessionStorage.setItem("currentLocationId", loc);
        if (locations.length > 0 && locationIndex === -1) {
          sessionStorage.setItem("currentLocationId", locations[0]?.id);
          if (!window.location.pathname.includes("browser-ext")) {
            const phone = `${location.split("/")[3]}`.replace("/", "");
            if (phone && !isEmpty(phone) && phone !== "undefined") {
              window.history.pushState(
                "",
                "",
                `/engagements/activity-center/${phone}?loc=${locations[0]?.id}`
              );
            } else {
              window.history.pushState("", "", `/engagements/activity-center`);
            }
            sessionStorage.getItem("currentLocationId") !== loc && window.location.reload();
          }
        }
      } else {
        const locationId = locations.findIndex(
          el => +el?.id === +sessionStorage.getItem("currentLocationId")
        );
        if (locationId === -1 && handleisAll() === false && locations.length > 0) {
          let sLocations = locations[0].id;
          const crmIntegrationType = getActiveCrmIntegration(sLocations);
          if (crmIntegrationType === "DT") {
            sLocations = locations.map(location => location.id).join(",");
          }
          sessionStorage.setItem("currentLocationId", sLocations);
        }
      }

      // if (locations.length > 0) {
      //   setLocationList(locations);
      // } else {
      //   setLocationList([meData?.me?.location]);
      //   sessionStorage.setItem("currentLocationId", meData?.me?.location?.id);
      // }
    }
  };

  useEffect(() => {
    if (
      (!sessionStorage.getItem("currentLocationId") ||
        sessionStorage.getItem("currentLocationId") === null) &&
      user?.location?.id
    ) {
      sessionStorage.setItem("currentLocationId", user?.location?.id);
    }
  }, [location2, user]);

  useEffect(() => {
    setLocation(
      sessionStorage.getItem("currentLocationId")?.includes(",") ||
        sessionStorage.getItem("currentLocationId") == null ||
        sessionStorage.getItem("currentLocationId") === "undefined"
        ? "all"
        : sessionStorage.getItem("currentLocationId")
    );
  }, [changed]);

  useEffect(() => {
    localStorage.removeItem("isOpporDialogFlagChangedLocal");
    localStorage.removeItem("clickLeadId");
    try {
      let qPhone = isReportRouteMatch(window.location.pathname)
        ? ""
        : `${location.split("/")[3]}`.replace("/", "");
      if (locationName) {
        return;
      }
      if (window.location.pathname.includes("browser-ext")) {
        qPhone = `${location.split("/")[2]}`.replace("/", "");
      }
      queryStringLocation = !isEmpty(document.location.search) ? loc : meData?.locationId;
      if (!isEmpty(qPhone) && queryStringLocation !== "undefined") {
        setPhone(qPhone);
      } else if (!isEmpty(sessionStorage.getItem("currentLocationId"))) {
        setLocation(sessionStorage.getItem("currentLocationId"));
      } else {
        setLocation(user?.locationId || "");
      }
    } catch (err) {
      console.log("Error in useEffect[]", err);
    }
  }, []);

  useEffect(() => {
    if (meData) {
      // console.log("layout.js:useeffect on medata: present");
      !user?.id && updateUser(meData.me);
      if (
        isEmpty(sessionStorage.getItem("currentLocationId")) &&
        queryStringLocation === "" &&
        !loc
      ) {
        sessionStorage.setItem(
          "currentLocationId",
          (meData.me && String(meData?.me?.locationId || "")) || undefined
        );
        setLocation((meData.me && String(meData?.me?.locationId || "")) || undefined);
      }
      setUserAccessLocations({ ...user, ...meData.me });
      fsIdentify(user);
      posthogIdentify(user);
      const fcmToken = sessionStorage.getItem("fcmToken") || "";
      if (fcmToken === "" || fcmToken == null) {
        const messaging = getMessaging();
        getToken(messaging, {
          vapidKey: process.env.GATSBY_VAPID_KEY || "",
        })
          .then(currentToken => {
            if (currentToken) {
              const data = {
                registrationId: currentToken,
              };
              createFcmDevice({
                variables: {
                  ...data,
                },
              }).then(res => {
                if (res?.data?.createFcmDevice?.statusCode === 200) {
                  sessionStorage.setItem("fcmToken", currentToken);
                }
              });
            }
          })
          .catch(err => {
            console.log("An error occurred while retrieving token. ", err);
          });
      }
    }
  }, [meData]);

  const fetchUser = async () => {
    const userData = await getMe();
    if (userData) {
      refetchPermissions().then(permissions => {
        updateUserWithPermissions(userData.data?.me, permissions?.data?.getUserPermissionActions);
      });
    }
  };

  useEffect(() => {
    if (!user?.id) {
      fetchUser();
    }
  }, [user]);

  useEffect(() => {
    if (user.id && userIds.length === 0 && sessionStorage.getItem("isLogin")) {
      dispatch(reducerSetAppointmentUserIds([+user.id]));
    }
  }, [user]);

  const getDifferedState = async setState => {
    let differedState;
    await new Promise(resolve =>
      // eslint-disable-next-line no-promise-executor-return
      setState(data => {
        differedState = data;
        resolve();
        return data;
      })
    );
    return differedState;
  };
  useEffect(() => {
    // EAI-1486: while an admin is impersonating a user, route them like the
    // target (a normal user), NOT to the admin dashboard. The Cognito token
    // is still ADMIN, so without this guard the admin-only redirects below
    // would trap the session on /admin-dashboard and hide the app the target
    // actually uses (activity-center, etc.).
    const isAdminRouting =
      getCognitoRoles(accessPayload)[0] === "ADMIN" && !isImpersonating();
    if (location === "/") {
      if (isAdminRouting) {
        navigate("/admin-dashboard");
      } else {
        navigate("/engagements/activity-center");
      }
      if (!sessionStorage.getItem("isInitialUrlSet")) {
        sessionStorage.setItem("isInitialUrlSet", true);
      }
    } else if (isAdminRouting) {
      navigate("/admin-dashboard");
      sessionStorage.setItem("isInitialUrlSet", true);
    } else if (
      !sessionStorage.getItem("isInitialUrlSet") &&
      !window.location.pathname.includes("browser-ext") &&
      !window.location.pathname.includes("call-detail") &&
      !queryString
    ) {
      // if phone number or queryString is present into Url than do not redirect to main url and keep url with phone and query string
      const qPhone = `${location.split("/")[3]}`.replace("/", "");
      if (!qPhone) {
        navigate("/engagements/activity-center");
        sessionStorage.setItem("isInitialUrlSet", true);
      }
    }
  }, []);

  // Separate effect for user-dependent state that doesn't need socket
  useEffect(() => {
    if (user && user?.id) {
      setUserFullName(user.fullName);
      setcurrentUserCompany(user.company.id);
    }
  }, [user]);

  // Keep a ref to the latest user so socket handlers always see current state
  const userRef = React.useRef(user);
  useEffect(() => {
    userRef.current = user;
  }, [user]);

  // Socket initialization — only runs once when user.id becomes available.
  // Uses effective roles so that while impersonating (token still ADMIN) the
  // socket DOES initialize — the impersonated user needs live messaging.
  useEffect(() => {
    if (!user?.id || getEffectiveCognitoRoles(accessPayload)[0] === "ADMIN") {
      return;
    }

    // If socket already exists and is connected, skip re-initialization
    if (socket?.connected) {
      return;
    }

    const activeSocket =
      socket ||
      io.connect(`${endPoint}`, {
        transports: ["websocket", "polling"],
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 10000,
        timeout: 20000,
      });

    if (!socket) {
      setSocket(activeSocket);
    } else if (!activeSocket.connected) {
      activeSocket.connect();
    }
  }, [user?.id]);

  // Force reconnect when the browser tab becomes visible again
  // Browsers throttle background tabs which can silently kill WebSocket connections
  useEffect(() => {
    if (!socket) return;

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible" && !socket.connected) {
        console.log("Tab became visible, socket disconnected — forcing reconnect");
        socket.connect();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [socket]);

  // Socket event listeners — separate effect that depends on the socket instance
  useEffect(() => {
    if (!socket || !user?.id || getEffectiveCognitoRoles(accessPayload)[0] === "ADMIN") {
      return;
    }

    const onConnect = () => {
      console.log(
        "Socket connected. ID:",
        socket.id,
        " Transport:",
        socket.io?.engine?.transport?.name
      );
    };

    const onDisconnect = reason => {
      console.log("Socket disconnected. Reason:", reason);
      // Socket.IO built-in reconnection handles reconnecting automatically
      // for all reasons EXCEPT "io server disconnect" which means the server
      // intentionally closed the connection.
      if (reason === "io server disconnect") {
        socket.connect();
      }
    };

    const onReconnect = attemptNumber => {
      console.log("Socket reconnected after", attemptNumber, "attempts. ID:", socket.id);
    };

    const onReconnectAttempt = attemptNumber => {
      console.log(`Socket reconnect attempt #${attemptNumber}`);
    };

    const onReconnectError = err => {
      console.log("Socket reconnect_error:", err?.message);
    };

    const onConnectError = err => {
      console.log("Socket connect_error:", err?.message, " Connected:", socket.connected);
    };

    const onUpdateCount = async data => {
      dispatch(
        setLeadCountChange({
          ...data,
        })
      );
    };

    const onMessageNotesAssigned = async data => {
      const currentUser = userRef.current;
      // Only show notifications relevant to the currently logged-in user
      if (+data?.user_id === +currentUser?.id) {
        const locations = await getDifferedState(setlocation2);
        if (
          getEffectiveCognitoRoles(accessPayload)[0] !== "ADMIN" &&
          locations.findIndex(item => +item?.id === +data?.location_id) !== -1
        ) {
          showToast(
            "info",
            "Message Note Assigned",
            data?.message || "You have been assigned a new message note.",
            data?.lead_id
          );
        }
      }
    };

    // Drop incoming message events whose root opp-type doesn't match the
    // user's active activity-center tab. BE stamps ``root_opp_type_id``
    // on the broadcast payload (see ``api/utils/message_trigger.py``
    // ``broadcast_sent_message``); the active tab is mirrored to a
    // window global by engagementActivity.js. The legacy-safe rules:
    //   - no active tab (``__ACTIVE_OPP_TYPE_ID__`` falsy)        → keep
    //   - payload has no ``root_opp_type_id`` (legacy / opp-less) → keep
    //   - tab matches root                                        → keep
    //   - otherwise (mismatch)                                    → DROP, and
    //     bump the off-tab's unread counter via
    //     ``window.__BUMP_UNREAD_BY_ROOT__`` (registered by
    //     engagementActivity.js) so the tab strip can render a red
    //     dot for the user.
    // Without this filter, a Service-tab user would see Sales messages
    // pop into the lead list and the open thread the moment they arrive.
    const shouldDropForActiveTab = data => {
      const incomingRoot = data?.root_opp_type_id;
      if (incomingRoot == null) return false;
      // eslint-disable-next-line no-underscore-dangle
      const activeTab = window.__ACTIVE_OPP_TYPE_ID__;
      if (!activeTab) return false;
      if (Number(incomingRoot) === Number(activeTab)) return false;
      // Bumping the off-tab counter is the WHOLE point of dropping —
      // otherwise the user gets no signal that there's activity in
      // the other tab. Guarded behind a typeof check so a stale
      // socket event arriving after engagementActivity unmounted
      // (e.g. user routed away from activity center) doesn't crash.
      // eslint-disable-next-line no-underscore-dangle
      const bump = window.__BUMP_UNREAD_BY_ROOT__;
      if (typeof bump === "function") {
        try {
          bump(incomingRoot);
        } catch (e) {
          // Best-effort — never let a notify failure block the drop.
        }
      }
      return true;
    };

    // When the server tells the socket that a message was received, show a toast message and post a message to the
    // parent (in case of the browser extension). Also, update the state to show the notification.
    // Do not show toast messages or notifications for messages sent to the lead.
    const handleRecievedMessageFromSocket = async data => {
      if (shouldDropForActiveTab(data)) return;
      const currentUser = userRef.current;
      const isPageDashboard =
        window.location.pathname.includes("dashboard") ||
        window.location.pathname.includes("reviews");
      if (isPageDashboard) {
        return;
      }
      // Only show notifications relevant to the currently logged-in user
      if (+data?.user_id === +currentUser?.id) {
        const locations = await getDifferedState(setlocation2);
        if (
          getEffectiveCognitoRoles(accessPayload)[0] !== "ADMIN" &&
          (!data?.direction || (data?.direction && data?.direction !== "TO_LEAD")) &&
          locations.findIndex(item => +item?.id === +data?.location_id) !== -1
        ) {
          if (window) {
            window.location.pathname.includes("browser-ext") &&
              window.parent.postMessage(
                {
                  event_id: "notification_trigger",
                  data: {
                    notification: true,
                  },
                },
                "*"
              );
          }
          //  The following condition checks if new leads come up: if the notification data contains a lead object and this lead object exists in the location list,
          // then add this lead as a new lead to the list.

          // This condition fully stop Dashbaord auto refreshing as auto refreshing causes frequently refreshing
          if (
            window.location.pathname.includes("activity-center") ||
            window.location.pathname.includes("browser-ext")
          ) {
            if (data?.lead) {
              setNewLead({ ...data?.lead });
              setAddNewLead(true);
            } else {
              setNewLead({});
              setAddNewLead(false);
            }
          }
          if (!data?.direction || (data?.direction && data?.direction !== "TO_LEAD")) {
            showToast("success", "NEW MESSAGE", data?.message, data?.lead_id);
          }
          // This condition fully stop Dashbaord auto refreshing as auto refreshing causes frequently refreshing
          if (
            window.location.pathname.includes("activity-center") ||
            window.location.pathname.includes("browser-ext")
          ) {
            setNotificationData({ ...data });
          }
          // Always refresh notification count on incoming messages with a delay to ensure backend has processed the message
          setTimeout(() => {
            refetchNotificationsCount();
          }, 6000);
        }
      } else if (
        window.location.pathname.includes("activity-center") ||
        window.location.pathname.includes("browser-ext")
      ) {
        setNotificationData({ ...data });
      }
    };

    const onReceivedMessage = async data => {
      await handleRecievedMessageFromSocket(data);
    };

    const onSentMessage = async data => {
      if (shouldDropForActiveTab(data)) return;
      const currentUser = userRef.current;
      // Phase 3a: skip the leadList-mutating notification path for our own
      // outbound TO_LEAD sends — replaceQueuedMessage + the engagementActivity
      // useEffect already merge the persisted message into the open lead's
      // timeline. Falling through to setNotificationData causes the lead
      // list to unshift the lead and breaks the active selection highlight.
      const isOwnOutbound =
        +data?.user_id === +currentUser?.id &&
        Array.isArray(data?.lead_messages) &&
        (data.lead_messages[0]?.direction || "TO_LEAD") === "TO_LEAD";

      const isNotificationExistInLocation = checkLocation(data?.location_id);
      if (isNotificationExistInLocation && !isOwnOutbound) {
        const isPageDashboard =
          window.location.pathname.includes("dashboard") ||
          window.location.pathname.includes("reviews");
        !isPageDashboard && setNotificationData({ ...data });
      }
      // Phase 3a: the persisted Message merge is handled inside
      // engagementActivity.js's own SocketIO listener (which has direct
      // access to the timeline state via selectedLead). Dispatching to
      // Redux here too caused a leadList re-render that dropped the
      // selection highlight, so this dispatch is intentionally omitted.
    };

    socket.on(SOCKET_EVENTS.CONNECT, onConnect);
    socket.on(SOCKET_EVENTS.DISCONNECT, onDisconnect);
    socket.on(SOCKET_EVENTS.CONNECT_ERROR, onConnectError);
    socket.io.on(SOCKET_EVENTS.RECONNECT, onReconnect);
    socket.io.on(SOCKET_EVENTS.RECONNECT_ATTEMPT, onReconnectAttempt);
    socket.io.on(SOCKET_EVENTS.RECONNECT_ERROR, onReconnectError);
    socket.on(SOCKET_EVENTS.UPDATE_COUNT, onUpdateCount);
    socket.on(SOCKET_EVENTS.MESSAGE_NOTES_ASSIGNED, onMessageNotesAssigned);
    socket.on(SOCKET_EVENTS.RECEIVED_MESSAGE, onReceivedMessage);
    socket.on(SOCKET_EVENTS.SENT_MESSAGE, onSentMessage);

    localStorage.setItem("callSocket", "false");

    // Clean up all listeners when effect re-runs or component unmounts
    return () => {
      socket.off(SOCKET_EVENTS.CONNECT, onConnect);
      socket.off(SOCKET_EVENTS.DISCONNECT, onDisconnect);
      socket.off(SOCKET_EVENTS.CONNECT_ERROR, onConnectError);
      socket.io.off(SOCKET_EVENTS.RECONNECT, onReconnect);
      socket.io.off(SOCKET_EVENTS.RECONNECT_ATTEMPT, onReconnectAttempt);
      socket.io.off(SOCKET_EVENTS.RECONNECT_ERROR, onReconnectError);
      socket.off(SOCKET_EVENTS.UPDATE_COUNT, onUpdateCount);
      socket.off(SOCKET_EVENTS.MESSAGE_NOTES_ASSIGNED, onMessageNotesAssigned);
      socket.off(SOCKET_EVENTS.RECEIVED_MESSAGE, onReceivedMessage);
      socket.off(SOCKET_EVENTS.SENT_MESSAGE, onSentMessage);
    };
  }, [socket, user?.id]);

  useQuery(GET_CRM_INTEGRATION_TYPE, {
    fetchPolicy: "cache-and-network",
    onCompleted: res => {
      if (res) {
        dispatch(setCrmType(res?.getCrmLeadStatus?.crmIntegrationType || ""));
      }
    },
  });

  useEffect(() => {
    if (user.userAccounts) {
      setUserAccounts(user.userAccounts);
      if (user.userAccounts.length > 1 && getEffectiveCognitoRoles(accessPayload)[0] !== "ADMIN") {
        setShowUserAccountOptions(true);
      }
      const userAccountOpts = user.userAccounts.map(userAccount => (
        <Select.Option key={userAccount.id} title={userAccount.name} value={userAccount.id}>
          {userAccount.name}
        </Select.Option>
      ));
      setUserAccountOptions(userAccountOpts);
    }
  }, [user]);

  function deleteAllCookies() {
    const cookies = document.cookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    }
  }

  useEffect(() => {
    if (meError) {
      if (meError.message?.includes("Unauthorized") && !isSigningOut.current) {
        isSigningOut.current = true;
        // Show the logout overlay immediately. This is a forced sign-out
        // (token rejected), so we skip the BE pre-logout mutation but
        // still want the user to see "Signing out…" instead of the
        // empty-state layout while Cognito + redirect resolve.
        signalLogoutStarted();
        Auth.signOut().then(() => {
          sessionStorage.clear();
          localStorage.clear();
          deleteAllCookies();
          if (persistor) {
            persistor.pause();
            persistor.flush().then(() => persistor.purge());
          }
          dispatch(resetApiCacheStore({}));
          dispatch(resetFilters());
          if (process.env.GATSBY_POSTHOG_API_KEY) {
            window?.posthog?.reset();
          }
          window.location.href = "/";
        });
      } else if (meError.message?.includes("Signature has expired")) {
        Auth.currentSession()
          .then(session => session.getRefreshToken())
          .then(refreshToken => Auth.user.refreshSession(refreshToken));
      }
    }
  }, [meError]);

  if (
    user &&
    user.company &&
    (user.isDisabled || user.company.isDisabled) &&
    canRedirect &&
    !isSigningOut.current
  ) {
    isSigningOut.current = true;
    // Pre-logout BE cleanup (user-scoped cache busts) before Cognito.
    runPreLogout().finally(() => {
      Auth.signOut().then(() => {
        sessionStorage.clear();
        localStorage.clear();
        deleteAllCookies();
        if (persistor) {
          persistor.pause();
          persistor.flush().then(() => persistor.purge());
        }
        dispatch(resetApiCacheStore({}));
        dispatch(resetFilters());
        if (process.env.GATSBY_POSTHOG_API_KEY) {
          window?.posthog?.reset();
        }
        window.location.href = "/";
      });
    });
  }

  const handleMobileView = () => {
    dispatch(setMobileView({ isMobileView: window.innerWidth <= 800 }));
  };

  useEffect(() => {
    // Initial call
    handleMobileView();
    refetchNotificationsCount();
    // Attach event listener
    const handleResize = () => {
      handleMobileView();
    };

    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleSavePhone = () => {
    if (mobileaddModal?.data?.phone && isPossiblePhoneNumber(mobileaddModal?.data?.phone)) {
      updateUserPhone({
        variables: { phone: mobileaddModal.data.phone },
      });
    } else {
      message.error(lang.enterValidPhone);
    }
  };

  const skip = () => {
    setmobileaddModal(prev => ({
      ...mobileaddModal,
      modalState: !prev.modalState,
      data: {},
    }));
    localStorage.setItem("showPhone", false);
  };

  const view = mobileaddModal.modalState ? (
    <UpdatePhone
      phoneSpinner={phoneSpinner}
      handleSavePhone={handleSavePhone}
      loading={loading}
      mobileaddModal={mobileaddModal}
      setmobileaddModal={setmobileaddModal}
      skip={skip}
    />
  ) : window.location.href?.includes("browser-ext") ? (
    meData ? (
      (() => {
        const BrowserExtensionPopup = window.location.pathname.startsWith("/browser-ext-v4")
          ? BrowserExtensionPopupV4
          : window.location.pathname.startsWith("/browser-ext-v3")
          ? BrowserExtensionPopupV3
          : BrowserExtensionPopupV2;
        return (
          <>
            <Toast
              toastList={list}
              autoDelete={checkValue}
              autoDeleteTime={autoDeleteTime}
              onClickofToast={leadId => setSocketMsgSelectedLead(leadId)}
              isFromLayout
            />
            <BrowserExtensionPopup
              Role={getCognitoRoles(accessPayload)[0]}
              setchanged={setchanged}
              changed={changed}
              setLocation={setLocation}
              getActiveCrmIntegration={getActiveCrmIntegration}
              location2={location2}
              location={location}
              locationChatBot={locationChatBot}
              currentLocation={sessionStorage.getItem("currentLocationId")}
              gotLocationId={gotLocationId}
              setPhone={setPhone}
              notificationsCount={notificationsCount}
              refetchNotificationsCount={refetchNotificationsCount}
            />
          </>
        );
      })()
    ) : (
      <Spin className="fixed top-[50%] left-[50%]" />
    )
  ) : (
    <MainLayout
      accessPayload={accessPayload}
      permissionLeader={permissionLeader}
      list={list}
      checkValue={checkValue}
      autoDeleteTime={autoDeleteTime}
      setSocketMsgSelectedLead={setSocketMsgSelectedLead}
      setPhone={setPhone}
      location2={location2}
      setLocation={setLocation}
      getActiveCrmIntegration={getActiveCrmIntegration}
      setUser={setUser}
      persistor={persistor}
      currentPath={currentPath}
      user={user}
      setchanged={setchanged}
      changed={changed}
      setShowSupportModal={setShowSupportModal}
      deleteFcmDevice={deleteFcmDevice}
      userFullName={userFullName}
      setContentStyle={setContentStyle}
      contentStyle={contentStyle}
      notificationsCount={notificationsCount}
      refetchNotificationsCount={refetchNotificationsCount}
    >
      {children}
    </MainLayout>
  );
  return view;
};

export default Layout;
